import { render, staticRenderFns } from "./SelectorResponsibleWarranty.vue?vue&type=template&id=a843530a&"
import script from "./SelectorResponsibleWarranty.vue?vue&type=script&lang=ts&"
export * from "./SelectorResponsibleWarranty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports